import { type HTMLArkProps, ark } from '@ark-ui/react';

import { cn } from '../../lib/utils';

type LinkProps = HTMLArkProps<'a'> & {
	underline?: 'auto' | 'hover' | 'always';
};

function Link({ className, underline = 'auto', ...props }: LinkProps) {
	return (
		<ark.a
			data-slot="link"
			data-underline={underline}
			className={cn('pt-link', className)}
			{...props}
		/>
	);
}

export { Link, type LinkProps };
